import React from 'react';
import { useFocusIdx } from '@bay-email/editor';
import { InputWithUnitField } from '../../../components/Form';
import { pixelAdapter } from '../adapter';
import { usePageDefaults } from '@extensions/hooks/usePageDefaults';
import { t } from '@bay-email/core';

export function FontSize() {
  const { focusIdx } = useFocusIdx();
  const { fontSize } = usePageDefaults();

  return (
    <InputWithUnitField
      label={t('Font size (px)')}
      name={`${focusIdx}.attributes.font-size`}
      config={pixelAdapter}
      autoComplete='off'
      placeholder={fontSize}
    />
  );
}
